import { Text } from '@customerio/pluma-components/react';
import * as styles from './index.css';

export function ShimmerText({ children }: { children: React.ReactNode }) {
  return (
    <div>
      <Text className={styles.shimmerText}>{children}</Text>
    </div>
  );
}
